import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/product',
    name: 'Product',
    component: () => import(/* webpackChunkName: "product" */ '../views/Product.vue')
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import(/* webpackChunkName: "product" */ '../views/Searchitem.vue')
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: () => import(/* webpackChunkName: "product" */ '../views/Checkout.vue')
  },
  {
    path: '/customer',
    name: 'Customer',
    component: () => import(/* webpackChunkName: "product" */ '../views/CustomerDetails.vue')
  },
  {
    path: '/singleitem',
    name: 'Singleitem',
    component: () => import(/* webpackChunkName: "product" */ '../views/Singleitemview.vue')
  },
  {
    path: '/singleitem2',
    name: 'Singleitem2',
    component: () => import(/* webpackChunkName: "product" */ '../views/Singleitemview2.vue')
  },
  {
    path: '/catogory',
    name: 'Category',
    component: () => import(/* webpackChunkName: "product" */ '../views/Catgoryitems.vue')
  },
  {
    path: '/account',
    name: 'Account',
    component: () => import(/* webpackChunkName: "product" */ '../views/Account.vue')
  },
  {
    path: '/offerzone',
    name: 'Offerzone',
    component: () => import(/* webpackChunkName: "product" */ '../views/Offerzone.vue')
  },
  {
    path: '/wishlist',
    name: 'Wishlist',
    component: () => import(/* webpackChunkName: "product" */ '../views/Wishlist.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "product" */ '../views/Register.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "product" */ '../views/Login.vue')
  },
  {
    path: '/editaddress',
    name: 'editaddress',
    component: () => import(/* webpackChunkName: "product" */ '../views/Edtaddress.vue')
  },
  {
    path: '/updateprofile',
    name: 'updateprofile',
    component: () => import(/* webpackChunkName: "product" */ '../views/updateprofile.vue')
  },
  
  
]

const router = new VueRouter({
  routes
})

export default router
